module.exports = __webpack_public_path__ + "img/mini-punto-verde2.3a294c7f.png";